import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';

const EMPLOYER_SIGNUP_PATH = '/signup?type=employer';

const PublicBuildRequestPaymentReturnPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const isCancelled = searchParams.get('cancelled') === 'true';

  return (
    <div className="min-h-screen bg-[#f8faf9] font-body text-[#0f172a]">
      <main className="mx-auto flex min-h-screen w-full max-w-[720px] flex-col justify-center px-4 py-10 sm:px-6">
        <section className="rounded-[18px] border border-[#dbe4e1] bg-white px-5 py-7 shadow-[0_18px_40px_rgba(15,23,42,0.06)] sm:px-8 sm:py-8">
          <div className="flex items-center gap-3">
            <div className="flex h-10 w-10 items-center justify-center rounded-[12px] bg-[#0d9488] text-[19px] font-bold text-white">
              I
            </div>
            <p className="font-display text-[22px] font-bold tracking-[0.04em] text-[#0f766e] sm:text-[24px]">
              INTELLERVIEW
            </p>
          </div>

          {isCancelled ? (
            <>
              <h1 className="mt-7 font-display text-[28px] font-bold leading-tight text-[#0f172a] sm:text-[34px]">
                Payment not completed.
              </h1>
              <p className="mt-3 text-[15px] leading-7 text-[#475569]">
                Your PayFast payment was cancelled before completion.
              </p>
              <p className="mt-3 text-[15px] leading-7 text-[#475569]">
                You can use your invoice payment link again when you are ready.
              </p>
            </>
          ) : (
            <>
              <h1 className="mt-7 font-display text-[28px] font-bold leading-tight text-[#0f172a] sm:text-[34px]">
                Payment received. Your simulation has been allocated for build.
              </h1>
              <p className="mt-3 text-[15px] leading-7 text-[#475569]">
                Your simulation is now in our build queue. We will complete the build and move it through final checks before deployment to your dashboard.
              </p>
              <p className="mt-3 text-[15px] leading-7 text-[#475569]">
                Please create your Intellerview employer account so your build progress and completed simulations can be accessed from your dashboard.
              </p>
              <p className="mt-3 text-[15px] leading-7 text-[#475569]">
                (Note: Please use the same email address you used for the purchase.)
              </p>
            </>
          )}

          <Link className="iv-btn-primary mt-7 inline-flex" to={EMPLOYER_SIGNUP_PATH}>
            Create employer account
          </Link>
        </section>
      </main>
    </div>
  );
};

export default PublicBuildRequestPaymentReturnPage;
